import { LCD, SCANLINE_GAP_PX } from "../config";
import type { GridSize } from "../core/types";
import { computeLayout, type ViewLayout } from "./layout";

/** Canvas'ı sahiplenir: boyutlandırma, DPR dönüşümü ve yerleşim hesabı. */
export class Renderer {
  private readonly canvas: HTMLCanvasElement;
  private readonly ctx: CanvasRenderingContext2D;
  private layout: ViewLayout;

  constructor(canvas: HTMLCanvasElement, grid: GridSize) {
    this.canvas = canvas;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas 2D context alınamadı");
    this.ctx = ctx;
    this.layout = { cell: 20, offX: 0, offY: 0, headerH: 0, width: 0, height: 0 };
    this.resize(grid);
  }

  get view(): ViewLayout {
    return this.layout;
  }

  get context(): CanvasRenderingContext2D {
    return this.ctx;
  }

  /** Ekran boyutu değişti; canvas ve yerleşimi güncelle. */
  resize(grid: GridSize): void {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.canvas.width = Math.floor(width * dpr);
    this.canvas.height = Math.floor(height * dpr);
    this.canvas.style.width = `${width}px`;
    this.canvas.style.height = `${height}px`;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    this.layout = computeLayout(width, height, grid);
  }

  /** LCD zemini + retro tarama çizgisi dokusu. */
  drawBackground(): void {
    const { width, height } = this.layout;
    this.ctx.fillStyle = LCD.bg;
    this.ctx.fillRect(0, 0, width, height);
    this.ctx.fillStyle = "rgba(32, 48, 26, 0.045)";
    for (let y = 0; y < height; y += SCANLINE_GAP_PX) {
      this.ctx.fillRect(0, y, width, 1);
    }
  }
}
